import { useContext, createContext } from 'react'

import { getDefaultPortalContainer } from '../utils'

type PortalContextType = () => Element | null

export const PortalContext = createContext<PortalContextType>(() => null)

export const usePortalContainer = () => {
  const getContextPortalContainer = useContext(PortalContext)

  if (getContextPortalContainer()) {
    return getContextPortalContainer
  }

  return getDefaultPortalContainer
}
